import type { Ref } from 'vue';

export type ShipmentFormStopsPort = {
  validateStops?: () => Promise<boolean>;
  selectedByPathId?: Ref<Record<string, boolean>>;
  computingRoute?: Ref<boolean> | boolean;
  routingLoading?: Ref<boolean> | boolean;
  isRoutingBusy?: () => boolean;
};

export function isShipmentFormRoutingBusy(
  port: ShipmentFormStopsPort | null | undefined,
): boolean {
  if (!port) return false;
  const computing =
    typeof port.computingRoute === 'object' && port.computingRoute != null
      ? port.computingRoute.value
      : port.computingRoute;
  const loading =
    typeof port.routingLoading === 'object' && port.routingLoading != null
      ? port.routingLoading.value
      : port.routingLoading;
  return Boolean(computing || loading);
}

export function resolveShipmentFormRoutingBusy(
  port: ShipmentFormStopsPort | null | undefined,
): boolean {
  if (!port) return false;
  if (typeof port.isRoutingBusy === 'function') {
    return port.isRoutingBusy();
  }
  return isShipmentFormRoutingBusy(port);
}
